import {
  MDSPlanCard,
  MDSPlanCardSlot,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanId,
  MDSButton,
  MDSButtonVariant,
  MDSButtonSlotName,
  MDSBadge,
  MDSBadgeVariant,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
  MDSIcon,
  MDSIconKind,
} from "@/mds";
import { getProFeatures } from "@/pages/settings/components/subscription-management/data";
import { CardsRow, TitleAndBadgeContainer } from "./subscription.styles";
import { observer } from "mobx-react-lite";

interface Props {
  showPlanHeader?: boolean;
  planHeaderTitle?: string;
  planHeaderBadgeLabel?: string;
  planHeaderBadgeVariant?: MDSBadgeVariant;
  title?: string;
  priceText?: string;
  features?: string[];
  statusText?: string;
  titleBadgeLabel?: string | null;
  manageButtonLabel?: string;
  showManageButton?: boolean;
  showExternalLinkIcon?: boolean;
  maxWidth?: string;
  onManagePlan: () => void;
}

export const SubscribedPlanManagement: React.FC<Props> = observer(
  ({
    showPlanHeader = true,
    planHeaderTitle = "Pro Plan",
    planHeaderBadgeLabel = "Best for your usage",
    planHeaderBadgeVariant = MDSBadgeVariant.Emphasis,
    title = "Pro",
    priceText = "$12 / month",
    features = getProFeatures(),
    statusText = "Unlimited usage",
    titleBadgeLabel = "Unlimited",
    manageButtonLabel = "Manage Pro Plan",
    showManageButton = true,
    showExternalLinkIcon = false,
    maxWidth,
    onManagePlan,
  }) => {
    return (
      <>
        {showPlanHeader && (
          <TitleAndBadgeContainer>
            <MDSText variant={MDSTextVariant.HeaderL}>{planHeaderTitle}</MDSText>
            {planHeaderBadgeLabel && (
              <MDSBadge label={planHeaderBadgeLabel} variant={planHeaderBadgeVariant} />
            )}
          </TitleAndBadgeContainer>
        )}
        <CardsRow>
          {statusText && <MDSText>{statusText}</MDSText>}
          <MDSPlanCard
            plan={MDSPlanId.Paid}
            features={features}
            border={MDSPlanCardBorder.Emphasis}
            background={MDSPlanCardBackground.Emphasis}
            maxWidth={maxWidth}
          >
            <MDSText
              variant={MDSTextVariant.HeaderL}
              weight={MDSTextWeight.SemiBold}
              slot={MDSPlanCardSlot.Title}
            >
              {title}
            </MDSText>
            {titleBadgeLabel && (
              <MDSBadge
                label={titleBadgeLabel}
                variant={MDSBadgeVariant.MoreEmphasis}
                slot={MDSPlanCardSlot.TitleBadge}
              />
            )}
            <div slot={MDSPlanCardSlot.Price}>{priceText}</div>
            {showManageButton && (
              <MDSButton
                variant={MDSButtonVariant.Emphasis}
                onClick={onManagePlan}
                slot={MDSPlanCardSlot.Footer}
              >
                {manageButtonLabel}
                {showExternalLinkIcon && (
                  <MDSIcon kind={MDSIconKind.ExternalLink} slot={MDSButtonSlotName.RightIcon} />
                )}
              </MDSButton>
            )}
          </MDSPlanCard>
        </CardsRow>
      </>
    );
  }
);
